import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { region } from '../utils/region';

const checkIfUserInternal = (env, realm, email) => {
  if (env === 'staging' || realm === 'klarna') return 'yes';
  else {
    if (email && email.includes('@klarna.com')) return 'yes';
  }
  return 'no';
};

const GoogleAnalyticsHelmet = ({
  areCookiesAccepted,
  country,
  email,
  env,
  language,
  realm,
  title,
}) => {
  const subdomain = 'portal';
  const path = `${window.location.pathname}` + `${window.location.search}`;
  const location = country || region;
  const websiteName = location && location.toLowerCase();
  const isInternal = checkIfUserInternal(env, realm, email);

  const sanitizeString = string => string.replace(/'/g, '');

  const dataLayerObject = `
  {
    event: 'virtual pageview',
    slug: '${window.slug}',
    pageInfo: {
      path: '${sanitizeString(path)}',
      title: '${sanitizeString(title)}'
    },
    site: {
      websiteID: '${sanitizeString(subdomain)}',
      websiteName: '${sanitizeString(websiteName)}',
      websiteLanguage: '${sanitizeString(language)}',
      environment: '${sanitizeString(env)}',
      type: 'react',
      version: 1,
      campaign: ''
    },
    user: {
      acceptedCookies: '${areCookiesAccepted ? 'yes' : 'no'}',
      isInternal: '${sanitizeString(isInternal)}'
    }
  }
  `;
  return (
    <Helmet>
      <script>{`window.dataLayer.push(${dataLayerObject})`}</script>
    </Helmet>
  );
};

GoogleAnalyticsHelmet.propTypes = {
  areCookiesAccepted: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  env: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  realm: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default GoogleAnalyticsHelmet;
